<div class="container" [style.--color]="color()" [matTooltip]="tooltip()">
  <div class="pulse"></div>
  <div class="pulse-inner"></div>
</div>
